export default __webpack_public_path__ + "static/media/two-sm.59404edf.svg";